import React, { FC, ReactNode } from 'react';
import { deepDaoLogoCircle } from 'assets';
import styles from './styles.module.scss';
import { useHistoryPush } from 'hooks';
import { HeaderRectangularButton } from 'components';

interface BlurredProBannerProps {
    children: ReactNode;
    title?: string;
    description?: string;
}

export const BlurredProBanner: FC<BlurredProBannerProps> = ({
    children,
    title = 'Treasury and Governance is a DeepDAO Pro feature',
    description = 'Upgrade to Pro to access detailed financial and governance analytics',
}) => {
    const { navigateToProducts } = useHistoryPush();
    return (
        <div className={styles.container}>
            <div className={styles.banner}>
                <div className={styles.bannerContent}>
                    <img src={deepDaoLogoCircle} className={styles.logo} alt="DeepDAO" />
                    <h2 className={styles.title}>{title}</h2>
                    <p className={styles.description}>{description}</p>
                    <HeaderRectangularButton onClick={navigateToProducts} title={'Subscribe'} />
                </div>
            </div>
            <div className={styles.blurredContent}>{children}</div>
        </div>
    );
};
